module.exports = __webpack_public_path__ + "img/icon_51@2x.5ad436da.png";